<script>
import axios from '@/utils/axios';
import Swal from 'sweetalert2';

export default {
  inject: ['setLoading'],
  data() {
    return {
      title: "CPQ",
      text: "CPQ",
      tableColumns: [
        { key: 'name', label: 'Name' },
        { key: 'is_required', label: 'Required' },
        { key: 'sort_order', label: 'Sort Order' },
        { key: 'actions', label: 'Actions' },
      ],
      items: [],
      selected_item: '',
      optionsList: [],
      loading: false,
    };
  },
  computed: {
    text1() {
      return `Item Options (${this.optionsList.length})`;
    },
  },
  mounted() {
    this.fetchItems();
  },
  methods: {
    async fetchItems() {
      try {
        const res = await axios.get('/items');
        const payload = res.data.data;
        // handle both plain array and paginated ({ data: [...] }) responses
        this.items = Array.isArray(payload) ? payload : (payload?.data || []);
      } catch (error) {
        this.$swalToast(error.message, 'error');
      }
    },
    async fetchOptions() {
      if (!this.selected_item) { this.optionsList = []; return; }
      this.loading = true;
      try {
        const res = await axios.get(`/item-options/${this.selected_item}`);
        this.optionsList = res.data.data || [];
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.loading = false;
      }
    },
    async deleteOption(row) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: `Delete "${row.name}" option?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
      });
      if (!result.isConfirmed) return;
      this.setLoading(true);
      try {
        await axios.delete(`/item-options/${row.id}`);
        this.$swalToast('Option deleted');
        this.fetchOptions();
      } catch (error) {
        this.$swalToast(error.message, 'error');
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
          <vue-select
            :options="items"
            label="name"
            v-model="selected_item"
            :reduce="item => item.id"
            placeholder="Select an item"
            :clearable="true"
            @update:modelValue="fetchOptions"
            style="min-width: 220px;"
          ></vue-select>
          <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#item_option_modal"
            class="btn btn-primary d-flex align-items-center"
            @click="$refs.itemOptionModal.add(selected_item)"
            v-if="selected_item">
            <i class="ti ti-circle-plus me-2"></i>Add Option
          </a>
        </div>
      </div>

      <div class="card border-0 shadow-sm mb-0" style="border-radius:14px;">
        <div class="card-body px-3 pt-2 pb-3">
          <app-table :columns="tableColumns" :rows="optionsList" :loading="loading"
            empty-text="Select an item to view its options" empty-icon="ti ti-adjustments">

            <template #is_required="{ row }">
              <span :class="row.is_required ? 'badge bg-success' : 'badge bg-secondary'">
                {{ row.is_required ? 'Required' : 'Optional' }}
              </span>
            </template>

            <template #actions="{ row }">
              <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#item_option_value_modal"
                class="me-2" title="Manage Values" @click="$refs.itemOptionValueModal.open(row, selected_item)">
                <i class="ti ti-list-details"></i>
              </a>
              <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#item_option_modal"
                class="me-2" @click="$refs.itemOptionModal.edit(row)">
                <i class="ti ti-edit"></i>
              </a>
              <a href="javascript:void(0);" @click="deleteOption(row)">
                <i class="ti ti-trash text-danger"></i>
              </a>
            </template>

          </app-table>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>

  <item-option-modal ref="itemOptionModal" @updated="fetchOptions"></item-option-modal>
  <item-option-value-modal ref="itemOptionValueModal"></item-option-value-modal>
</template>